import { FalhaServico } from '../falha-servico';

export class NotaCredito{
    score: number;
    dataUltimaAtualizacao: string;
    falhaServico: FalhaServico;

}